import { RefiUpdateMfeCache } from './update-mfe-cache.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';

defineRefiElement('refi-common-update-mfe-cache', RefiUpdateMfeCache);
